var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-form-presenter"},[_c('b-form-checkbox',_vm._g({class:{ 'move-checkbox-up': _vm.moveUp },attrs:{"id":_vm.data.name,"checked":_vm.value}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.data.displayName)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }